<template>
  <div>
    <v-form>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap py-0>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Cari Hareket Ekle</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn @click="Kaydet()" flat> <span class="hidden-sm-and-down"> Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <a target="_self" v-bind:href="'#/carihareketler/index'">
                    <v-list-tile>
                      <v-list-tile-title>Hareket Listesi</v-list-tile-title>
                    </v-list-tile>
                  </a>


                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>
                    <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                      <v-autocomplete hide-details append-icon="search" label="Cari Seçiniz" :loading="loading" :items="statecari"
                        clearable="" item-text="text" cache-items="" item-value="id" :search-input.sync="search"
                        v-model="Movement.Current" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></v-autocomplete>
                      <tarihcomp :etiket="'Tarih'" :detaygizle="true" v-model="Movement.MovementDate" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                        v-bind:defaultvalue="'ok'"></tarihcomp>
                      <tarihcomp :etiket="'Vade Tarihi'" :detaygizle="true" v-model="Movement.MovementDueDate"
                        v-bind:defaultvalue="'ok'"></tarihcomp>
                      <v-autocomplete :items="EvrakTipi1" hide-details="" v-bind="EvrakTipi1" item-text="Title"
                        clearable item-value="Evrakkod" :rules="[v => !!v || 'Lütfen seçiniz']" v-model="Movement.DocumentType" label="Evrak Tipi"></v-autocomplete>
                      <v-text-field hide-details="" @blur="makbuztipkontrol()" rows="10px" label="Evrak No" v-model="Movement.DocumentNumber">
                      </v-text-field>
                      <v-select :items="states1" hide-details="" label="Borç/Alacak" item-text="text" item-value="value"
                        v-model="Movement.DebitCredit" :rules="[v => !!v || 'Lütfen seçiniz']" clearable></v-select>
                    </v-form>
                    <parainput :name="tutar" :error-messages="errors.collect('tutar')" v-model="Movement.Amount"
                      :etiket="etikettutar" data-vv-name="tutar" required v-validate="'required'" :id="tutar"
                      :autocomplete="autocomplete"></parainput>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-autocomplete :items="masrafmerkezi" hide-details="" label="Masraf Merkezi" item-text="CodeName"
                      clearable v-model="Movement.ExpenseCenter" item-value="Code"></v-autocomplete>




                    <v-autocomplete hide-details="" :items="Referans" label="Referans" v-model="Movement.Reference"
                      clearable item-text="ReferansAd" item-value="Kod"></v-autocomplete>

                    <v-select hide-details="" :items="makbuztipi" @select="evraktipkontrol()" label="Makbuz Tipi"
                      clearable item-text="text" v-model="Movement.ReceiptType" item-value="value"></v-select>

                    <v-textarea label="Açıklama" v-model="Movement.Explanation" value=""></v-textarea>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>
                    <v-autocomplete :items="doviztipi" item-text="DovizUnvan" @change="kurgetir(Movement.ExchangeType)"
                      item-value="DovizKod" hide-details="" v-model="Movement.ExchangeType" label="Döviz Tipi"
                      clearable></v-autocomplete>
                    <dovizinput v-model="Movement.ExchangeRate" :etiket="'Döviz Kur Tutar'" :autocomplete="autocomplete"></dovizinput>
                    <dovizinput :name="doviztutar" v-model="Movement.ExchangeAmount" :etiket="etiketdoviztutar" :id="doviztutar"
                      :autocomplete="autocomplete"></dovizinput>
                      <v-btn color="info" @click="karsicariac()" small block> Karşı Hareket Gir</v-btn>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


          <v-layout v-if="karsicari" row="" wrap="">
            <v-flex xs12 sm12 md12>

              <div v-if="karsicari">

                <v-card flat="" color="#9E9E9E">
                  <v-card-title>
                    <span class="subheading white--text font-weight-medium "> Karşı Hareket Bilgileri</span>
                  </v-card-title>
                </v-card>
              </div>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>


                      <v-autocomplete hide-details clearable label="Karşı Cari Seçiniz" autocomplete append-icon="search"
                        :loading="loading" :items="statecari2" item-text="text" cache-items="" item-value="id"
                        :search-input.sync="search1" v-model="Movement.ContraCurrent"></v-autocomplete>


                      <v-autocomplete :items="EvrakTipi2" clearable hide-details="" v-model="Movement.ContraDocumentType"
                        v-bind="EvrakTipi2" item-text="Aciklama" item-value="Evrakkod" label=" Karşı Evrak Tipi"></v-autocomplete>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>

            </v-flex>


            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-textarea label=" Karşı Açıklama" v-model="Movement.ContraExplanation" value=""></v-textarea>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-autocomplete hide-details="" @change="kurgetir1(Movement.ContraExchangeType)" :items="doviztipi"
                        item-text="DovizUnvan" item-value="DovizKod" clearable label=" Karşı Döviz Tipi" v-model="Movement.ContraExchangeType"></v-autocomplete>

                      <dovizinput v-model="Movement.ContraExchangeRate" :etiket="'Döviz Kur Tutar'" :autocomplete="autocomplete"></dovizinput>

                      <dovizinput :name="karsidoviztutar" v-model="Movement.ContraExchangeAmount" :etiket="karsietiktutar"
                        :id="karsidoviztutar" :autocomplete="autocomplete"></dovizinput>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-layout>


        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import parainput from '../customcomp/parainput'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'


  export default {

    props: {
      operation: ''
    },

    data() {
      return {
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        rules: {
          required: (value) => !!value || 'Gerekli alan.',
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Hatalı e-mail.'
          }
        },
        valid: true,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: ' #',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
        loading: false,
        search: '',
        search1: '',
        karsicari: true,
        statecari: [],
        statecari2: [],
        masrafmerkezi: [],
        Referans: [],
        states1: [{
          text: 'Alacak',
          value: 'A'
        }, {
          text: 'Borç',
          value: 'B'
        }],
        doviztipi: [],

        EvrakTipi1: [],
        EvrakTipi2: [],
        items1: [],

        Movement: {
          Current: '',
          ContraCurrent: 0,
          MovementDate: null,
          MovementDueDate: null,
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          DebitCredit: '',
          Amount: 0,
          ExchangeType: '',
          ExchangeRate: 0,
          ExchangeAmount: 0,
          ContraDocumentType: '',
          ContraDocumentNumber: '',
          ContraExplanation: '',
          ContraExchangeType: '',
          ContraExchangeRate: 0,
          ContraExchangeAmount: 0,
          PaymentCode: '',
          Reference: '',
          ExpenseCenter: null,
          CompanyCode: '',
          ReceiptType: '',
        },
        Movementyedek: {
          Current: null,
          ContraCurrent: 0,
          MovementDate: null,
          MovementDueDate: null,
          DocumentType: null,
          DocumentNumber: null,
          Explanation: null,
          DebitCredit: null,
          Amount: 0,
          ExchangeType: null,
          ExchangeRate: 0,
          ExchangeAmount: 0,
          ContraDocumentType: null,
          ContraDocumentNumber: null,
          ContraExplanation: null,
          ContraExchangeType: null,
          ContraExchangeRate: 0,
          ContraExchangeAmount: 0,
          PaymentCode: null,
          Reference: null,
          ExpenseCenter: null,
          CompanyCode: null,
          ReceiptType: null,
        },

        makbuztipi: [{
            text: 'Diğer',
            value: '0'
          },
          {
            text: 'Tahsil',
            value: '1'
          },
          {
            text: 'Tediye',
            value: '2'
          }
        ],
        dictionary: {
          custom: {
            carikod: {
              required: () => 'Lütfen seçiminizi yapınız',
            },
            tarih: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            ba: {
              required: () => 'Lütfen seçiminizi yapınız',
            },
            tutar: {
              required: () => 'Lütfen bir tutar giriniz',
              min_value: () => 'tutar 0 dan büyük olmalıdır'
            },

          }
        },
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,

        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: 'Tutar',

        doviztutar: 'doviztutar',
        etiketdoviztutar: 'Döviz Tutar',

        kurtutar: 'kurtutar',
        etiketkurtutar: 'Döviz Kuru',


        karsikurtutar: 'karsikurtutar',
        karsietiketkurtutar: 'Karşı Döviz Kuru',


        karsidoviztutar: 'karsidoviztutar',
        karsietiktutar: 'Karşı Döviz Tutar',

      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },

    methods: {

      kurgetir(kod) {
        var params1 = {
          Tarih: getDateNow(),
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Movement.ExchangeRate = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      kurgetir1(kod) {
        var params1 = {
          Tarih: getDateNow(),
          DovizKod: kod
        }
        this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Movement.ContraExchangeRate = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },


      karsicariac: karsicariac,
      carigetir: carigetir,
      carigetir1: carigetir1,
      Kaydet: Kaydet,

      evraktipkontrol: evraktipkontrol,
      makbuztipkontrol: makbuztipkontrol
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      dovizinput,
      tarihcomp
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val2) {
        val2 && this.carigetir1(val2)
      },
      'Movement.ExchangeRate': function (value) {
        if (value != 0) {
          this.Movement.ExchangeAmount = this.Movement.Amount / value;
        }

      }
    },

  }

  function makbuztipkontrol() {
    if (this.Movement.ReceiptType != '0' && this.Movement.ReceiptType != null && this.Movement.ReceiptType != '') {
      this.Movement.DocumentNumber = null
      this.text1 = 'Makbuz tipi seçili olduğundan evrak no giremezsiniz.'
      this.snackbar = true
    }
  }


  function evraktipkontrol() {
    if (this.Movement.ReceiptType != '0') {
      this.Movement.DocumentNumber = null
    }
  }

  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    if (this.$refs.formbiletrapor.validate()) {


      var currentMovement = this.Movement
      currentMovement['CompanyCode'] = credentials.SirketKodu
      this.$http.post(auth.API_URL + 'api/CurrentMovement/New', currentMovement, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status === true) {

          this.Movement = this.Movementyedek;

          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }

      })
    }
  }

  function karsicariac() {
    if (this.karsicari === false) {
      this.karsicari = true
      this.Movement.ContraExplanation = this.Movement.Explanation
      this.Movement.ContraDocumentType = this.Movement.DocumentType

    } else {
      this.karsicari = false

    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function carigetir(v) {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var query = {
          q: escape(v),
          c: credentials.SirketKodu
        }




    if (v.length > 3) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch',
         query, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader()
}
        }).then((response) => {
          this.statecari = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    } else {
      this.statecari = []
    }
  }

  function carigetir1(v) {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var query = {
          q: escape(v),
          c: credentials.SirketKodu
        }


    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', query, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Cari'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function beforeMount() {
    this.Movement.ReceiptType = null
    this.Movement.Reference = null

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu
    }


    //this.Movement.MovementDate = getDateNow();
    //this.Movement.MovementDueDate = getDateNow();


    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.EvrakTipi1 = response.body
      this.EvrakTipi2 = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Reference/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      }
    })
    this.karsicari = false
  }
</script>

<style>
</style>